import React from "react";
import clsx from "clsx";
import { ReactComponent as FinishIcon } from "../../icons/finishWorkout.svg";
import { Button } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import LoadingActionButton from "../button/LoadingActionButton";

const useStyles = makeStyles((theme) => {
  return {
    modal: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      backgroundColor: "rgba(0,0,0,0.7)",
      // TODO_API_V2_Z_INDEX: Refactor logic with using z-index
      zIndex: 9999999,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    modalContent: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      borderRadius: 4,
      boxShadow: theme.shadows[16],
      padding: "50px 99px",
    },
    titleModal: {
      fontSize: 24,
      fontWeight: "bold",
      lineHeight: "29px",
      marginTop: 24,
      marginBottom: 8,
    },
    textModal: {
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "17px",
      marginBottom: 24,
      color: theme.palette.text.secondary,
    },
    buttonFinish: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
      width: 310,
      fontWeight: "bold",
      fontSize: 16,
      lineHeight: "20px",
      padding: 18,
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
    buttonCancel: {
      marginTop: 24,
      backgroundColor: "transparent",
      color: theme.palette.text.secondary,
      "&:hover": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  };
});

const WorkoutFinishModal = (props: any) => {
  const { handleSubmit, onClose, loading } = props;
  const s = useStyles();
  return (
    <div className={clsx(s.modal)}>
      <div className={clsx(s.modalContent)}>
        <FinishIcon />
        <div className={clsx(s.titleModal)}>Finish workout</div>
        <div className={clsx(s.textModal)}>All exercises will be completed</div>
        <LoadingActionButton
          className={clsx(s.buttonFinish)}
          children={"Finish"}
          onClick={handleSubmit}
          loading={loading}
        />
        <Button
          className={clsx(s.buttonFinish, s.buttonCancel)}
          children={"Cancel"}
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default WorkoutFinishModal;
